// extracted by mini-css-extract-plugin
export default {"pageContainer_txdis":"TexasDisclosure_pageContainer_txdis__8Lki2","hero_image_txdis":"TexasDisclosure_hero_image_txdis__HktBW","heading_txdis":"TexasDisclosure_heading_txdis__gD2Cj"};